// Sight click values for the «shooterShots» advice card — Tilleggsmodul (C,
// shooting). Pure, no DOM. Every figure is a manufacturer statement at 25 m,
// verified 2026-10-15 against the source noted; pistols without a published
// value (Walther CSP, Tanfoglio, Sig P322 — LPA / screw sights) are left out
// and covered by the «custom» entry where the shooter types their own values.

export const CUSTOM_PISTOL = 'custom';

export const SIGHT_CLICK_PISTOLS = [
    {
        key: 'walther-gsp',
        name: 'Walther GSP / GSP Expert',
        windageMm: 5,
        elevationMm: 7,
        // Walther GSP manual (GSP_2505100_BA_komplett.pdf), «Rear sight adjustment»:
        // screw 5 «1 click = 5 mm on the target», screw 6 «1 click = 7 mm on the target».
        source: 'Walther GSP manual',
    },
    {
        key: 'walther-gsp500',
        name: 'Walther GSP500',
        windageMm: 5,
        elevationMm: 5,
        // all4shooters IWA 2022 launch article: «each click … changes the point of
        // impact by 0.5 cm at 25 meters» (not split by axis).
        source: 'Walther GSP500 launch (all4shooters)',
    },
    {
        key: 'pardini-sp',
        name: 'Pardini SP / SP22',
        windageMm: 5,
        elevationMm: 5,
        // pardini.it SP technical data: «Adjustment click: 5 mm».
        source: 'Pardini SP spec',
    },
    {
        key: 'hammerli-xesse',
        name: 'Hämmerli X-esse',
        windageMm: 5,
        elevationMm: 10,
        // Hämmerli Xesse manual §3.3.2.2: «At a distance of 25 meters, 1 click results
        // in: elevation correction approx. 1 cm, horizontal correction approx. 0.5 cm».
        // The Sport / IPSC variants carry an LPA sight with no published value.
        source: 'Hämmerli X-esse manual',
    },
];

// Custom values are whole millimetres: 4.6 → 5, anything under half a mm → 0.
function wholeMm(value) {
    const n = Math.round(Number(value));
    return Number.isFinite(n) && n > 0 ? n : 0;
}

/**
 * The click values to use: a listed pistol, or the shooter's own numbers for
 * «custom» (whole mm). null when nothing usable is chosen (then the advice stays in mm).
 * @returns { name, windageMm, elevationMm } | null
 */
export function resolveSight(pistolKey, custom = {}) {
    if (pistolKey === CUSTOM_PISTOL) {
        const windageMm = wholeMm(custom.windageMm);
        const elevationMm = wholeMm(custom.elevationMm);
        if (!windageMm && !elevationMm) return null;
        return { name: '', windageMm, elevationMm };
    }
    const pistol = SIGHT_CLICK_PISTOLS.find(p => p.key === pistolKey);
    return pistol ? { name: pistol.name, windageMm: pistol.windageMm, elevationMm: pistol.elevationMm } : null;
}

/**
 * Whole clicks for the sight move of a buildShotAdvice() result. An axis the
 * advice does not want moved, or without a click value, yields 0.
 * @returns { horizontal, vertical }
 */
export function clicksFor(advice, sight) {
    if (!advice || !sight) return { horizontal: 0, vertical: 0 };
    const horizontal = advice.move.horizontal && sight.windageMm > 0
        ? Math.round(Math.abs(advice.mpi.x) / sight.windageMm) : 0;
    const vertical = advice.move.vertical && sight.elevationMm > 0
        ? Math.round(Math.abs(advice.mpi.y) / sight.elevationMm) : 0;
    return { horizontal, vertical };
}
